// `en-XA` is a pseudo-locale exposed in non-production builds (localhost + PR
// previews). Gated by runtime hostname rather than `import.meta.env.DEV` so
// branch-preview builds — production-mode Vite builds served from
// `*.previews.growthvectors.io` — still expose the switcher entry. See
// `pseudoLocalize.ts` and the resources backend in `index.ts`.
import { isProduction } from "../utils/getUrlPrefix";

const BASE_LANGUAGES = ["en", "zh-Hans"] as const;
const DEV_LANGUAGES = ["en-XA"] as const;

export type SupportedLanguage = (typeof BASE_LANGUAGES)[number] | (typeof DEV_LANGUAGES)[number];

export const SUPPORTED_LANGUAGES: readonly SupportedLanguage[] =
  isProduction ? BASE_LANGUAGES : [...BASE_LANGUAGES, ...DEV_LANGUAGES];

export const isPersistedLanguage = (lng: string): boolean => (BASE_LANGUAGES as readonly string[]).includes(lng);

export const LANGUAGE_DISPLAY_NAMES: Record<SupportedLanguage, string> = {
  en: "English",
  "zh-Hans": "简体中文",
  "en-XA": "Pseudo (en-XA)",
};
